// start_param (t.me/<бот>/<имя>?startapp=<параметр>) → начальный маршрут: сущность <тип>_<номер>, вкладка tab_<ключ>,
// live, settings_push («Уведомления», кнопка бота W4). Грамматика (Р-7): ≤ 64 знаков [A-Za-z0-9_-]
// (алфавит Telegram); длиннее или с другими знаками — как неизвестный. Неизвестный параметр и home → вкладка по
// умолчанию (null). Рекламная метка едет в том же параметре после двойного подчёркивания: «match_123__bot-goal» → куда
// вести «match_123», метка «bot-goal» (её разбирает аналитика). Без «__» метки нет. Назначение может быть пустым («__tg-oct»).
import { paths } from './nav';

const VALID = /^[A-Za-z0-9_-]{1,64}$/;

/** Сущности: <префикс>_<номер> → экран. Лига 1 — экран чемпионата мира /world-cup (nav.paths.league). */
const ENTITIES: Record<string, (id: string) => string> = {
  match: paths.match, team: paths.team, player: paths.player, league: paths.league, news: paths.news, highlight: paths.highlight,
};

export function splitStartParam(param: string | undefined): { dest: string | undefined; label: string | null } {
  if (!param || !VALID.test(param)) return { dest: undefined, label: null };
  const i = param.indexOf('__');
  return i < 0 ? { dest: param, label: null } : { dest: param.slice(0, i) || undefined, label: param.slice(i + 2) || null };
}

export function routeFromStartParam(raw: string | undefined): string | null {
  const param = splitStartParam(raw).dest;
  if (!param || param === 'home') return null;
  // «Матчи» с включённым фильтром LIVE (матч-центр читает ?live=1)
  if (param === 'live') return paths.tab('matches', { live: true });
  // «Уведомления» — кнопка бота «Настроить» (W4, HQ-281)
  if (param === 'settings_push') return paths.notifications();
  // раздел — вкладка панели по ключу config (незнакомый ключ разберёт маршрут вкладки: → вкладка по умолчанию)
  const tab = /^tab_([a-z_]{1,32})$/.exec(param);
  if (tab) return paths.tab(tab[1]!);
  const m = /^([a-z]+)_(\d{1,12})$/.exec(param);
  const route = m ? ENTITIES[m[1]!] : undefined;
  return route ? route(m![2]!) : null;
}
